import React from "react";
import { createRoot } from "react-dom/client"; 
import "semantic-ui-css/semantic.min.css";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store/Store";
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { BrowserRouter as Router } from "react-router-dom";

const msalInstance = new PublicClientApplication(msalConfig);

// Preload critical images into browser cache
const preloadImages = [
  '/images/Logo.png', '/images/admin-console-icon.svg', '/images/ai-assistant.svg',
  '/images/data-console.svg', '/images/dashboard-title.svg', '/images/quick-chat-icon.svg',
  '/images/log_out.svg', '/images/grey-send.svg', '/images/copy-icon.svg',
  '/images/search.svg', '/images/chat-history.svg', '/images/filter.svg',
  '/images/group.svg', '/images/users.svg', '/images/user.svg', '/images/faq.svg',
  '/images/Help.svg', '/images/user-profile.svg',
];
preloadImages.forEach((src) => { new Image().src = src; });

if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
  msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback(async (event) => {
  if (
      (event.eventType === EventType.LOGIN_SUCCESS ||
          event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
          event.eventType === EventType.SSO_SILENT_SUCCESS) &&
      event.payload.account
  ) {
      msalInstance.setActiveAccount(event.payload.account);
  }
});

const root = document.getElementById("root");
const reactRoot = createRoot(root);

const renderApp = () => {
  reactRoot.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <Router>
            <App />
          </Router>
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  );
};

renderApp();
